"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoveUsersFromGroup = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
function useRemoveUsersFromGroup(groupId) {
    const { data, isLoading, error, del } = (0, core_ui_1.useApiDelete)(`groups/${groupId}/users`);
    const removeUsersFromGroup = (0, react_1.useCallback)((userId) => del({ userId }), [del]);
    return {
        data,
        isLoading,
        error,
        removeUsersFromGroup
    };
}
exports.useRemoveUsersFromGroup = useRemoveUsersFromGroup;
//# sourceMappingURL=useRemoveUsersFromGroup.js.map